export enum LandStatusEnum {
  FREEHOLD = 'Freehold',
  LEASEHOLD = 'Leasehold',
  VIRTUAL_FREEHOLD = 'VirtualFreehold',
}
